var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 256C57.4254 256 0 198.575 0 128C0 57.4254 57.4254 0 128 0C198.575 0 256 57.4254 256 128C256 198.575 198.575 256 128 256ZM128 46.5455C83.0836 46.5455 46.5455 83.0836 46.5455 128C46.5455 172.916 83.0836 209.455 128 209.455C172.916 209.455 209.455 172.916 209.455 128C209.455 83.0836 172.916 46.5455 128 46.5455Z",
    fill: "#A7A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelosIcon);
export default __webpack_public_path__ + "static/media/telos-icon.acca63c5eba4787fd5cd0133751b43b9.svg";
export { ForwardRef as ReactComponent };